<template>
    <div
        :class="preview ? 'h-[calc(100vh)] bg-[#334155]' : 'md:h-[calc(100vh-128px)]'"
        class="relative grid grid-cols-1 md:grid-cols-10"
    >
        <div
            :class="preview ? 'md:col-span-10' : 'md:col-span-6'"
            class="w-full relative"
        >
            <ProductImages
                :desk-material="selectedDeskMaterial"
                :frameMaterial="selectedFrameMaterial"
                :desk="desk"
                :preview="preview"
                :deskRadius="selectedDeskRadius"
                :isIframe="isIframe"
            ></ProductImages>
            <div
                v-if="!preview"
                class="absolute flex-col gap-4 flex right-6 sm:right-28 md:right-8 lg:right-28 top-6 md:top-8 lg:top-8 xl:top-8 opacity-50"
            >
                <!--                <div class="tooltip hidden md:block" data-tip="Neem Screenshot">-->
                <!--                    <button @mousedown="takeScreenshot" class="btn btn-circle shadow mx-auto">-->
                <!--                        <i class="fa-solid fa-camera"></i>-->
                <!--                    </button>-->
                <!--                </div>-->
                <!--                <div class="tooltip hidden md:block"-->
                <!--                     :data-tip="showDesktop ? 'Verberg Laptop (MacBook Pro 16&quot;)' : 'Toon Laptop (MacBook Pro 16&quot;)'">-->
                <!--                    <button @mousedown="toggleDeskSetup" class="btn btn-circle shadow mx-auto"-->
                <!--                            :class="{ 'btn-success text-white': showDesktop }">-->
                <!--                        <i class="fa-solid fa-laptop"></i>-->
                <!--                    </button>-->
                <!--                </div>-->
                <div
                    class="controller hidden md:flex flex-col gap-2 bg-primary rounded-full shadow w-12 mx-auto"
                >
                    <div class="tooltip" data-tip="Staan (120cm)">
                        <button
                            @pointerdown="startMovingDesk(1)"
                            @pointerup="stopMovingDesk"
                            @pointerleave="stopMovingDesk"
                            class="btn btn-circle shadow-xl -mt-1"
                        >
                            <i
                                class="fa-solid fa-person-simple text-xl text-primary"
                            ></i>
                        </button>
                    </div>
                    <p class="text-center text-white font-bold">
                        {{ Math.floor(tableHeight) }} <br /><small>cm</small>
                    </p>
                    <div class="tooltip" data-tip="Zitten (75cm)">
                        <button
                            @pointerdown="startMovingDesk(-1)"
                            @pointerup="stopMovingDesk"
                            @pointerleave="stopMovingDesk"
                            class="btn btn-circle shadow-xl -mb-1"
                        >
                            <i class="fa-solid fa-chair-office text-xl"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="!preview"
            class="sidebar overflow-y-auto px-4 pb-8 md:pb-40 md:pt-10 flex flex-col gap-6 w-full col-span-4 h-[calc(45vh)] md:h-[calc(100vh-108px)] relative"
        >
            <button
                @click="shareLink"
                class="absolute top-5 right-5 text-primary text-md"
            >
                <i class="fa-regular fa-share-nodes"></i>
            </button>
            <div>
                <h1 class="font-bold">{{ desk ? desk.name : "Level One" }}</h1>
                <p
                    class="flex flex-row gap-4 text-left justify-start align-middle w-full mt-2 mb-4"
                >
                    <span
                        :class="{
                            'line-through leading-7 text-xl text-gray-400':
                                discountedPrice.value < price.value,
                            'font-bold text-xl':
                                discountedPrice.value >= price.value,
                        }"
                    >
                        <Money :value="price.value"></Money>
                    </span>
                    <span
                        class="font-bold text-xl leading-7 text-gray-600"
                        v-if="discountedPrice.value < price.value"
                    >
                        <Money :value="discountedPrice.value"></Money>
                    </span>
                </p>
                <p class="cambay-bold mb-3 text-gray-700">
                    {{ trans("components.configurator.color") }}
                </p>
                <div
                    class="materials grid grid-cols-4 xl:grid-cols-6 flex-wrap gap-2 lg:gap-6"
                >
                    <div
                        class="flex flex-col"
                        v-for="material in deskMaterials"
                    >
                        <button
                            :key="material.name"
                            :title="material.name"
                            :class="{
                                'outline outline-2 outline-offset-2 outline-primary':
                                    selectedDeskMaterial.id === material.id,
                            }"
                            :style="getButtonStyle(material)"
                            class="aspect-[4/3] shadow-none bg-white hover:bg-white tooltip border-2 border-gray-200 rounded-xl hover:border-gray-300"
                            @click="setDeskMaterial(material, true)"
                            @mouseover="setDeskMaterial(material)"
                            @mouseleave="setDeskMaterial(selectedDeskMaterial)"
                        ></button>
                    </div>
                </div>
                <p class="text-left mt-4 text-gray-500">
                    {{ trans("components.configurator.chosen_color") }}:
                    <span class="font-bold text-gray-800">{{
                        selectedDeskMaterial.name
                    }}</span>
                    <span class="font-extrabold text-primary text-center"
                        >+
                        <Money
                            :value="
                                selectedDeskMaterial.square_price -
                                baseMaterialPrice
                            "
                        ></Money
                        ><span class="font-light text-gray-400">/m²</span></span
                    >
                </p>
            </div>
            <div class="">
                <p class="cambay-bold mb-3 text-gray-700">
                    {{ trans("components.configurator.corners") }}
                </p>
                <div
                    class="grid grid-cols-3 xl:grid-cols-6 flex-wrap gap-2 lg:gap-6"
                >
                    <div
                        class="flex flex-col"
                        v-for="option in deskRadiusOptions"
                    >
                        <button
                            :class="{
                                'outline outline-2 outline-offset-2 outline-primary':
                                    selectedDeskRadius === option.radius,
                            }"
                            class="aspect-[4/3] tooltip border-2 border-gray-200 rounded-xl hover:border-gray-300 py-4"
                            @click="setDeskRadius(option.radius, true)"
                            @mouseover="setDeskRadius(option.radius)"
                            @mouseleave="setDeskRadius(selectedDeskRadius)"
                        >
                            <span
                                class="block mx-auto h-8 w-8 border-t-4 border-r-4 border-[#181D27]"
                                :style="
                                    'border-top-right-radius:' +
                                    option.radius * 2 +
                                    'px'
                                "
                            ></span>
                        </button>
                    </div>
                </div>
                <p class="text-left mt-4 text-gray-500">
                    {{ trans("components.configurator.chosen_form") }}:
                    <span class="font-bold text-gray-800">{{
                        selectedDeskRadius
                            ? trans("components.configurator.rounded")
                            : trans("components.configurator.right")
                    }}</span>
                    <span class="font-extrabold text-primary text-center"
                        >+ <Money v-if="selectedDeskRadius" :value="20"></Money
                        ><Money v-else :value="0"></Money
                    ></span>
                </p>
            </div>
            <div v-if="isProductPage">
                <p class="cambay-bold mb-3 text-gray-700">
                    {{ trans("components.configurator.size") }}
                </p>
                <div class="flex flex-col flex-wrap gap-2">
                    <div
                        v-for="defaultSize in defaultSizes"
                        :class="{
                            'bg-gray-200 ':
                                tabletopSize['depth'] === defaultSize.depth &&
                                tabletopSize['width'] === defaultSize.width,
                        }"
                        class="font-bold tooltip flex flex-row justify-between gap-8 py-2 px-4 cursor-pointer rounded-xl"
                        @click="
                            updateSize('depth', defaultSize.depth, true),
                                updateSize('width', defaultSize.width, true)
                        "
                    >
                        <div class="flex flex-row justify-start gap-8">
                            <p class="text-xl text-center">
                                {{ defaultSize.label }}
                            </p>
                        </div>
                        <i
                            v-if="
                                tabletopSize['depth'] === defaultSize.depth &&
                                tabletopSize['width'] === defaultSize.width
                            "
                            class="fa-solid fa-check text-primary text-xl text-center justify-self-end"
                        ></i>
                    </div>
                    <div
                        class="font-bold tooltip flex flex-row justify-between gap-8 py-2 px-4 cursor-pointer rounded-xl"
                        @click="enableConfigurator"
                    >
                        <div class="flex flex-row justify-start gap-8">
                            <p class="text-xl text-center">
                                <!--                                <i class="fa-solid fa-sliders "></i>-->
                                {{
                                    trans("components.configurator.choose_size")
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-8" v-else>
                <TableSizeSelector
                    :title="trans('components.configurator.width')"
                    :size="tabletopSize.width"
                    :presetSizes="presetsWidth"
                    :min="120"
                    :max="200"
                    @update:size="updateSize('width', $event, true)"
                    @range:update:size="updateSize('width', $event, false)"
                />
                <TableSizeSelector
                    :title="trans('components.configurator.depth')"
                    :size="tabletopSize.depth"
                    :presetSizes="presetsDepth"
                    :min="60"
                    :max="100"
                    @update:size="updateSize('depth', $event, true)"
                    @range:update:size="updateSize('depth', $event, false)"
                />

                <div
                    v-if="
                        defaultSizes.filter(
                            (size) =>
                                size.width === tabletopSize.width &&
                                size.depth === tabletopSize.depth
                        ).length === 0
                    "
                    class="text-sm"
                >
                    {{ trans("components.configurator.choose_size_desc") }}
                    <span class="font-extrabold text-primary"
                        ><Money :value="40"></Money></span
                    >. <br /><span
                        class="underline cursor-pointer"
                        @click="isProductPage = true"
                        >{{
                            trans("components.configurator.show_basic_sizes")
                        }}</span
                    >
                </div>
            </div>
            <div class="">
                <p class="cambay-bold mb-3 text-gray-700">
                    {{ trans("components.configurator.color_base") }}
                </p>
                <div class="materials flex flex-col gap-2">
                    <div
                        v-for="material in frameMaterials"
                        :key="material.name"
                        :class="{
                            'bg-gray-200 ':
                                selectedFrameMaterial.id === material.id,
                        }"
                        class="font-bold tooltip flex flex-row justify-between gap-8 py-2 px-4 cursor-pointer rounded-xl"
                        @click="setFrameMaterial(material, true)"
                        @mouseover="setFrameMaterial(material)"
                        @mouseleave="setFrameMaterial(selectedFrameMaterial)"
                    >
                        <div class="flex flex-row justify-start gap-4">
                            <span
                                aria-hidden="true"
                                :style="
                                    'background-color: ' +
                                    material.color_inside +
                                    ';border-color:' +
                                    material.color_outside
                                "
                                :class="[
                                    'block h-8 w-8 rounded-full border border-black border-opacity-10',
                                ]"
                            />
                            <p class="text-xl text-center">
                                {{ material.name }}
                            </p>
                        </div>
                        <i
                            v-if="selectedFrameMaterial.id === material.id"
                            class="fa-solid fa-check text-primary text-xl text-center justify-self-end"
                        ></i>
                    </div>
                </div>
            </div>
            <div v-if="accessories">
                <p class="cambay-bold mb-3 text-gray-700">
                    {{ trans("components.configurator.accessories") }}
                </p>
                <div class="flex flex-col flex-wrap gap-2">
                    <div
                        v-for="accessory in accessories.filter(
                            (accessory) => accessory.product_category_id === 2
                        )"
                        :class="{
                            'bg-gray-200 ':
                                selectedAccessories.includes(accessory),
                        }"
                        class="font-bold tooltip flex flex-row justify-between gap-8 py-2 px-4 cursor-pointer rounded-xl"
                        @click="
                            selectedAccessories.includes(accessory)
                                ? selectedAccessories.splice(
                                      selectedAccessories.indexOf(accessory),
                                      1
                                  )
                                : selectedAccessories.push(accessory)
                        "
                    >
                        <div class="flex flex-row justify-start gap-8">
                            <p class="text-xl text-center">
                                {{ getTranslatedValue(accessory, "title") }}
                            </p>
                            <span
                                >+
                                <Money
                                    :value="accessory.vatIncludedPrice"
                                ></Money
                            ></span>
                        </div>
                        <i
                            v-if="selectedAccessories.includes(accessory)"
                            class="fa-solid fa-check text-primary text-xl text-center justify-self-end"
                        ></i>
                    </div>
                </div>
            </div>
            <div>
                <p class="cambay-bold mb-3 text-gray-700">
                    {{
                        desk
                            ? trans("components.configurator.included")
                            : trans("components.configurator.controller")
                    }}
                </p>
                <div class="flex flex-row flex-wrap gap-2">
                    <div
                        class="card bg-base-200 w-full cursor-pointer"
                        v-if="!desk"
                        @click="unselectController"
                        :class="{ 'border border-black': !selectedController }"
                    >
                        <div class="card-body">
                            <span
                                class="label label-text font-bold flex flex-row justify-center text-center gap-x-4"
                            >
                                <i
                                    class="fa-sharp fa-light fa-mobile-notch"
                                ></i>
                                {{
                                    trans(
                                        "components.configurator.no_controller_only_app"
                                    )
                                }}</span
                            >
                        </div>
                    </div>
                    <div class="grid grid-cols-3 gap-2" v-if="desk">
                        <div
                            class="card bg-white shadow-x border border-gray-200"
                            v-for="product in desk.products"
                        >
                            <figure>
                                <img
                                    :src="product.image"
                                    alt="Standing desk controller"
                                />
                            </figure>
                            <div class="flex flex-col gap-1 p-2">
                                <p
                                    class="label label-text font-bold justify-between"
                                >
                                    <span>{{
                                        getTranslatedValue(product, "title")
                                    }}</span>
                                </p>
                                <div
                                    v-if="product.id === 8"
                                    class="flex flex-row justify-center gap-2 w-full col-span-2 xl:col-span-1 text-center"
                                >
                                    <button
                                        @click="
                                            initDeskReceiver();
                                            showDownloadModal = true;
                                        "
                                        class="btn btn-outline btn-sm hidden md:flex flex-grow"
                                    >
                                        {{
                                            trans(
                                                "components.configurator.test"
                                            )
                                        }}
                                    </button>
                                    <Modal
                                        :show="showDownloadModal"
                                        @close="showDownloadModal = false"
                                        :maxWidth="'max-w-screen-lg'"
                                    >
                                        <div
                                            class="bg-[#53389E] flex flex-col md:flex-row items-center rounded-2xl"
                                        >
                                            <div
                                                class="p-6 md:p-10 flex flex-col justify-center"
                                            >
                                                <h3
                                                    class="text-white text-3xl sm:text-4xl mb-4 text-balance"
                                                    v-html="
                                                        trans(
                                                            'components.configurator.popup.title'
                                                        )
                                                    "
                                                ></h3>
                                                <p
                                                    class="mb-8 text-balance text-white font-light max-w-[350px]"
                                                >
                                                    {{
                                                        trans(
                                                            "components.configurator.popup.description"
                                                        )
                                                    }}
                                                </p>
                                                <div class="flex gap-4">
                                                    <a :href="appleAppStoreUrl">
                                                        <img
                                                            src="/images/apple-app-store.svg"
                                                            class="h-[45px] px-4 py-2 border border-white rounded-lg"
                                                        />
                                                    </a>
                                                    <a
                                                        :href="
                                                            googlePlayStoreUrl
                                                        "
                                                    >
                                                        <img
                                                            src="/images/google-play-store.svg"
                                                            class="h-[45px] px-4 py-2 border border-white rounded-lg"
                                                        />
                                                    </a>
                                                </div>
                                                <div
                                                    class="mt-10"
                                                    v-if="deskReceiverDemoCode"
                                                >
                                                    <label
                                                        class="form-control w-full max-w-xs"
                                                    >
                                                        <div class="label">
                                                            <span
                                                                class="label-text text-white text-xl"
                                                            >
                                                                {{
                                                                    trans(
                                                                        "components.configurator.popup.code"
                                                                    )
                                                                }}
                                                            </span>
                                                        </div>
                                                        <input
                                                            class="input text-center text-xl font-bold"
                                                            readonly
                                                            :value="
                                                                deskReceiverDemoCode
                                                            "
                                                        />
                                                        <div class="label">
                                                            <span
                                                                class="label-text-alt text-white"
                                                            >
                                                                {{
                                                                    trans(
                                                                        "components.configurator.popup.code_subtitle"
                                                                    )
                                                                }}
                                                            </span>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                            <div
                                                class="px-10 flex justify-center items-center"
                                            >
                                                <img
                                                    src="/images/app-mockup-v3.webp"
                                                    class="w-[450px] pt-4 pb-4 md:pt-10"
                                                />
                                            </div>
                                        </div>
                                    </Modal>
                                </div>
                                <p
                                    class="label hidden md:block label-text pt-1"
                                    v-else
                                >
                                    {{
                                        getTranslatedValue(
                                            product,
                                            "description"
                                        )
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button
                @click="order"
                class="btn btn-primary text-white text-md flex-grow"
            >
                <i class="fa-solid fa-basket-shopping-plus text-white"></i>
                {{ trans("components.configurator.in_cart") }}
            </button>
            <p
                class="text-center tooltip"
                :data-tip="trans('components.configurator.shipping_tip')"
            >
                <i class="fa-regular fa-truck-fast"></i>
                {{ trans("components.configurator.shipping") }}
                <i class="fa-solid fa-circle-info"></i>
            </p>
        </div>
    </div>
    <div class="bg-gray-50 mt-5 pb-10" v-if="!preview">
        <specs
            :size="tabletopSize"
            :desk-material="selectedDeskMaterial"
            :frameMaterial="selectedFrameMaterial"
            :desk="desk"
            :deskRadius="selectedDeskRadius"
        ></specs>
        <div class="block">
            <div
                class="bg-white mx-auto max-w-2xl flex flex-col justify-center align-middle gap-4 p-4 rounded-xl text-center"
            >
                <div class="testimonial-from justify-center">
                    <div class="image">
                        <img
                            src="/images/testimonial-1.png"
                            alt="Stel ons vragen"
                            class="mx-auto"
                        />
                    </div>
                </div>
                <p class="font-bold text-black">
                    {{ trans("components.configurator.contact_question") }}
                </p>
                <p>
                    {{ trans("components.configurator.contact_description") }}
                </p>
                <a
                    hreflang="nl"
                    :href="route('contact')"
                    class="btn btn-primary btn-md w-52 mx-auto"
                    >{{ trans("components.configurator.contact_button") }}</a
                >
            </div>
        </div>
    </div>
    <our-materials v-if="!preview"></our-materials>
</template>

<script setup>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { computed, onMounted, reactive, ref, watch } from "vue";
import TWEEN from "three/addons/libs/tween.module.js";
import Specs from "@/Components/Specs.vue";
import Money from "@/Components/Money.vue";
import Modal from "@/Components/Modal.vue";
import { CustomEnvironment } from "@/Classes/CustomEnvironment.js";
import { TableTop } from "@/Classes/TableTop.js";
import { TableFrame } from "@/Classes/TableFrame.js";
import { DeskSetup } from "@/Classes/DeskSetup.js";
import { Accessories } from "@/Classes/Accessories.js";
import { distance } from "three/nodes";
import { DeskTween } from "@/Classes/Animation/DeskTween.js";
import { DeskReceiver } from "@/Services/DeskControllerClient.js";
import TableSizeSelector from "@/Components/TableSizeSelector.vue";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import { reportConnectAppDemo, reportAddToCart } from "@/Utils/Analytics";
import ProductImages from "@components/ProductImages.vue";
import OurMaterials from "@/Pages/category/sections/our-materials.vue";
import { usePage } from "@inertiajs/vue3";
import { trans } from "laravel-vue-i18n";
import { getTranslatedValue } from "@/Utils/TranslationUtils";

const props = defineProps({
    deskMaterials: Array,
    frameMaterials: Array,
    accessories: Array,
    deskControllerOptions: Object,
    preview: Boolean,
    desk: Object,
    baseMaterialPrice: Number,
    defaultSizes: Array,
    isIframe: Boolean,
});

let container;
let camera, scene, renderer;
let controls;
let screenSize;
let tableTopInnerMaterial, tableTopOuterMaterial, frameMaterial;
let renderTarget, cubeMap, generatedCubeRenderTarget;
let pmremGenerator;
let showDesktop = ref(false);
let desktop;
let showDownloadModal = ref(false);
let isTopPage = ref(true);
let isProductPage = ref(true);

let selectedDeskRadius = ref(5);
const deskRadiusOptions = ref([
    { radius: 0, name: trans("components.configurator.radius.square") },
    { radius: 5, name: trans("components.configurator.radius.subtle") },
    { radius: 10, name: trans("components.configurator.radius.round") },
]);

let roomSize = {
    depth: 600,
    width: 600,
    height: 300,
};
let tabletopSize = reactive({
    width: 140,
    depth: 70,
    height: 2,
});

const presetsDepth = props.defaultSizes.map((size) => size.depth);
const presetsWidth = props.defaultSizes.map((size) => size.width);
let room;
let tableHeight = ref(80);

let tableTop;
let frame;
let accessoryObjects;

/**
 * @type {DeskReceiver|undefined}
 */
let deskReceiver;

/**
 * @type {Ref<undefined|string>}
 */
let deskReceiverDemoCode = ref(undefined);

let price = reactive({ value: 0 });
let discountedPrice = reactive({ value: 0 });

let selectedFrameMaterial = ref(props.frameMaterials[0]);
let deskMaterials = ref();
if (props.desk && props.desk.materials) {
    deskMaterials.value = JSON.parse(JSON.stringify(props.desk.materials));
} else {
    deskMaterials.value = JSON.parse(JSON.stringify(props.deskMaterials));
}
let selectedDeskMaterial = ref(deskMaterials.value[0]);
const selectedAccessories = ref([]);

const $toast = useToast();

const deskTweenPosition = {
    _y: tableHeight.value,
    get y() {
        return this._y;
    },
    set y(value) {
        this._y = value;
        tableHeight.value = value;
    },
};
const updateSize = (type, targetSize, animate) => {
    if (animate) {
        const step = targetSize > tabletopSize[type] ? 1 : -1;
        const interval = setInterval(() => {
            if (tabletopSize[type] !== targetSize) {
                tabletopSize[type] += step;
            } else {
                clearInterval(interval);
            }
        }, 5); // Adjust the interval time as needed
    } else {
        tabletopSize[type] = parseInt(targetSize);
    }
};

const setDeskRadius = (radius, selectRadius = false) => {
    const previousRadius = selectedDeskRadius.value;
    selectedDeskRadius.value = radius;
    updateTable();
    debouncedCalculatePrice();
    if (!selectRadius) {
        selectedDeskRadius.value = previousRadius;
    }
};

const deskTween = new DeskTween(deskTweenPosition);

const updateDeskHeight = (height) => {
    deskTween.updateHeight(Math.min(Math.max(height, 63), 128));
    updateCameraHeight();
};

function updateTable() {
    if (tableTop) {
        scene.remove(tableTop);
    }
    tableTop = new TableTop(
        tabletopSize,
        tableHeight.value,
        tableTopOuterMaterial,
        tableTopInnerMaterial,
        selectedDeskRadius.value
    );
    scene.add(tableTop);
}

const getButtonStyle = (material) => {
    return (
        "background-position:bottom;background-size:cover;background-image: url(/textures/wood/renderpreviews/" +
        material.name.replace(/\s+/g, "").toLowerCase() +
        ".webp)"
    );
};

function addFloor() {
    let material = new THREE.ShadowMaterial({
        opacity: 0.05,
    });
    let floor = new THREE.Mesh(
        new THREE.BoxGeometry(roomSize.width, 1, roomSize.depth),
        material
    );

    floor.position.y = 0;
    floor.position.z = 0;
    floor.receiveShadow = true;
    return floor;
}

const renderEnvMap = () => {
    pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileCubemapShader();
    const envScene = new CustomEnvironment(distance, tableHeight.value, true);
    generatedCubeRenderTarget = pmremGenerator.fromScene(envScene);

    renderTarget = generatedCubeRenderTarget;
    cubeMap = generatedCubeRenderTarget.texture;
    const newEnvMap = renderTarget ? renderTarget.texture : null;

    if (
        newEnvMap &&
        tableTopInnerMaterial &&
        newEnvMap !== tableTopInnerMaterial.envMap
    ) {
        tableTopInnerMaterial.envMap = newEnvMap;
        tableTopInnerMaterial.needsUpdate = true;

        tableTopOuterMaterial.envMap = newEnvMap;
        tableTopOuterMaterial.needsUpdate = true;

        frameMaterial.envMap = newEnvMap;
        frameMaterial.needsUpdate = true;
    }

    scene.background = props.isIframe ? new THREE.Color(0x334155) : cubeMap;
    //scene.background = cubeMap;
    renderer.toneMappingExposure = 1;
};

const calculatePrice = () => {
    axios
        .post(route("price.calculate"), {
            width: tabletopSize.width,
            depth: tabletopSize.depth,
            radius: selectedDeskRadius.value,
            material_desk: selectedDeskMaterial.value.id,
            material_frame: selectedFrameMaterial.value.id,
            accessories: selectedAccessories.value.map(
                (accessory) => accessory.id
            ),
        })
        .then(function (response) {
            price.value = response.data.price;
            discountedPrice.value = response.data.discounted_price;
        });
};
const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
};
const debouncedCalculatePrice = debounce(calculatePrice, 300);

watch(
    () => tabletopSize,
    (old, current) => {
        updateTable();
        updateFrame();
        updateAccessories();
        debouncedCalculatePrice();
    },
    { deep: true }
);

watch(
    () => tableHeight.value,
    (height) => {
        tableTop.updateHeight(height);
        frame.updateHeight(height);
        if (accessoryObjects) {
            accessoryObjects.updateHeight(height);
        }
        if (desktop) {
            desktop.updateHeight(height);
        }
        //camera.lookAt(new THREE.Vector3(0, tableHeight.value, tabletopSize.depth / 2))
        notifyStateUpdate();
    }
);

watch(
    () => selectedDeskMaterial,
    () => {
        debouncedCalculatePrice();
    },
    { deep: true }
);

watch(
    () => selectedAccessories,
    () => {
        updateAccessories();
        debouncedCalculatePrice();
    },
    { deep: true }
);

//watch scroll position
window.addEventListener("scroll", () => {
    isTopPage.value = window.scrollY <= 100;
});

const order = () => {
    cameraToBase(0);
    if (showDesktop.value) {
        toggleDeskSetup();
    }
    setTimeout(function () {
        const screenshot = getScreenshot();
        axios
            .post(route("order.submit"), {
                width: tabletopSize.width,
                depth: tabletopSize.depth,
                material_desk: selectedDeskMaterial.value.id,
                material_frame: selectedFrameMaterial.value.id,
                accessories: selectedAccessories.value.map(
                    (accessory) => accessory.id
                ),
                radius: selectedDeskRadius.value,
                screenshot: screenshot,
            })
            .then(function (response) {
                reportAddToCart([{ price: price.value, quantity: 1 }]); // TODO - add real order item data
                window.location.href = route("shoppingcart.preview");
            });
    }, 50);
};

const shareLink = () => {
    let link = window.location.href;
    const accessoriesIds = selectedAccessories.value
        .map((accessory) => accessory.id)
        .join(",");
    link += `&w=${tabletopSize.width}&d=${tabletopSize.depth}&r=${selectedDeskRadius.value}&fm=${selectedFrameMaterial.value.id}&dm=${selectedDeskMaterial.value.id}&a=${accessoriesIds}`;

    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
            .writeText(link)
            .then(() => {
                $toast.open({
                    message: trans(
                        "components.configurator.message.link_copied"
                    ),
                    type: "success",
                    dismissible: true,
                });
            })
            .catch((err) => {
                $toast.open({
                    message: trans(
                        "components.configurator.message.link_copy_failed"
                    ),
                    type: "warning",
                    dismissible: true,
                });
            });
    } else {
        const textArea = document.createElement("textarea");
        textArea.value = link;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand("copy");
            $toast.open({
                message: trans("components.configurator.message.link_copied"),
                type: "success",
                dismissible: true,
            });
        } catch (err) {
            $toast.open({
                message: trans(
                    "components.configurator.message.link_copy_failed"
                ),
                type: "warning",
                dismissible: true,
            });
        }
        document.body.removeChild(textArea);
    }
};

const presetTableFromLink = () => {
    const urlParams = new URLSearchParams(window.location.search);

    // Set default values
    const defaultWidth = props.defaultSizes[0].width;
    const defaultDepth = props.defaultSizes[0].depth;
    const defaultRadius = 5;

    if (urlParams.has("w")) {
        let width = parseInt(urlParams.get("w"));
        if (isNaN(width) || width < 120 || width > 200) {
            width = defaultWidth;
        }
        updateSize("width", width, false);
    }

    if (urlParams.has("d")) {
        let depth = parseInt(urlParams.get("d"));
        if (isNaN(depth) || depth < 60 || depth > 100) {
            depth = defaultDepth;
        }
        updateSize("depth", depth, false);
    }

    if (urlParams.has("r")) {
        let radius = parseInt(urlParams.get("r"));
        const validRadii = [0, 5, 10];
        if (!validRadii.includes(radius)) {
            radius = defaultRadius;
        }
        setDeskRadius(radius, true);
    }

    if (urlParams.has("dm")) {
        const deskMaterialId = parseInt(urlParams.get("dm"));
        setDeskMaterial(
            deskMaterials.value.find(
                (material) => material.id === deskMaterialId
            ),
            true
        );
    }

    if (urlParams.has("fm")) {
        const frameMaterialId = parseInt(urlParams.get("fm"));
        setFrameMaterial(
            props.frameMaterials.find(
                (material) => material.id === frameMaterialId
            ),
            true
        );
    }

    if (urlParams.has("a")) {
        const accessoriesIds = urlParams.get("a")
            ? urlParams
                  .get("a")
                  .split(",")
                  .map((id) => parseInt(id, 10))
            : [];
        selectedAccessories.value = props.accessories.filter((accessory) =>
            accessoriesIds.includes(accessory.id)
        );
    }
};

const presetTableFromDesk = (desk) => {
    updateSize("width", desk.width, false);
    updateSize("depth", desk.depth, false);
    setDeskRadius(parseInt(desk.table_radius), true);
    const deskMaterialId = parseInt(desk.desk_material_id);
    setDeskMaterial(
        deskMaterials.value.find((material) => material.id === deskMaterialId),
        true
    );
    const frameMaterialId = parseInt(desk.frame_material_id);
    setFrameMaterial(
        props.frameMaterials.find(
            (material) => material.id === frameMaterialId
        ),
        true
    );
    const accessoriesIds = desk.products.map((product) => product.id);
    selectedAccessories.value = props.accessories.filter((accessory) =>
        accessoriesIds.includes(accessory.id)
    );
};

const enableConfigurator = () => {
    isProductPage.value = false;
    setTimeout(() => {
        // Ensure container is correctly referenced
        container = document.getElementById("three");
        screenSize.width = container.offsetWidth;
        screenSize.height = container.offsetHeight;

        // Update camera
        camera.aspect = screenSize.width / screenSize.height;
        camera.updateProjectionMatrix();

        // Update renderer
        renderer.setSize(screenSize.width, screenSize.height);

        // Manually trigger the render to ensure the scene is updated
        renderer.render(scene, camera);
    }, 100);
};

let selectedController = ref(null);
const selectController = (controller) => {
    if (selectedController.value) {
        //remove current selected controller from accessories to add the new one
        selectedAccessories.value = selectedAccessories.value.filter(
            (accessory) => accessory.id !== selectedController.value.id
        );
    }

    if (
        selectedController.value &&
        controller.id === selectedController.value.id
    ) {
        // unselect the controller if the same one is clicked to unselect it
        selectedController.value = null;
    } else {
        selectedController.value = controller;
        selectedAccessories.value.push(controller);
    }
};

const unselectController = () => {
    if (selectedController.value) {
        //remove current selected controller from accessories to add the new one
        selectedAccessories.value = selectedAccessories.value.filter(
            (accessory) => accessory.id !== selectedController.value.id
        );
    }

    selectedController.value = null;
};

const initThreeJSScene = () => {
    const distance = 400;
    container = document.getElementById("three");
    screenSize = {
        width: container.offsetWidth,
        height: container.offsetHeight,
    };

    // const lookAt = new THREE.Vector3(0, tableHeight.value +100, 0);

    scene = new CustomEnvironment(distance, tableHeight.value, false);

    scene.add(addFloor());
    updateTable();
    updateFrame();

    //Renderer
    renderer = new THREE.WebGLRenderer({
        antialias: true,
    });

    renderer.setSize(container.offsetWidth, container.offsetHeight);
    //renderer.setClearColor(scene.fog.color);
    renderer.shadowMap.enabled = true;
    renderer.shadowMapType = THREE.PCFSoftShadowMap; // options are THREE.BasicShadowMap | THREE.PCFShadowMap | THREE.PCFSoftShadowMap
    renderer.physicallyCorrectLights = true;
    renderer.setPixelRatio(window.devicePixelRatio);

    container.appendChild(renderer.domElement);

    renderer.gammaInput = true;
    renderer.gammaOutput = true;

    renderer.shadowMapEnabled = true;

    // camera
    camera = new THREE.PerspectiveCamera(
        45,
        screenSize.width / screenSize.height,
        0.1,
        distance
    );
    camera.position.x = 0;
    camera.position.y = tableHeight.value;
    camera.position.z = tabletopSize.depth / 2;
    //camera.lookAt(lookAt)
    scene.add(camera);

    controls = new OrbitControls(camera, container);
    controls.enableDamping = true;
    controls.dampingFactor = 0.1;
    controls.autoRotate = false;
    controls.autoRotateSpeed = 0.5;
    controls.minDistance = 150;
    controls.maxDistance = roomSize.depth / 1.5;
    controls.panSpeed = 0.001;
    controls.enabled = !props.preview;
    controls.enableZoom = false;
    controls.target.set(0, 60, 0);

    window.addEventListener("resize", onWindowResize);
};

const cameraToBase = (time = 300) => {
    new TWEEN.Tween(camera.position)
        .to(
            {
                x: -70,
                y: tableHeight.value * 2,
                z: 200,
            },
            time
        )
        .start();
};

const cameraToPreviewBase = (time = 300) => {
    new TWEEN.Tween(camera.position)
        .to(
            {
                x: 0,
                y: tableHeight.value + 25,
                z: 180,
            },
            time
        )
        .start();
};

const updateCameraHeight = (time = 250) => {
    new TWEEN.Tween(camera.position)
        .to(
            {
                y: tableHeight.value * 2,
            },
            time
        )
        .start();
};

const onWindowResize = () => {
    // Update screenSize
    screenSize.width = container.offsetWidth;
    screenSize.height = container.offsetHeight;

    // Update camera
    camera.aspect = screenSize.width / screenSize.height;
    camera.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(screenSize.width, screenSize.height);
};

const clock = new THREE.Clock();

const tick = () => {
    // const elapsedTime = clock.getElapsedTime();
    // stats.begin();
    if (camera.position.z < 450) {
        controls.autoRotateSpeed = -0.5;
    } else if (camera.position.x > 1350) {
        controls.autoRotateSpeed = 0.5;
    }
    controls.maxPolarAngle = Math.PI / 2.2;
    controls.minAzimuthAngle = -Math.PI / 1.8; // Limit left rotation
    controls.maxAzimuthAngle = Math.PI / 1.8; // Limit right rotation
    controls.update();

    // renderer.physicallyCorrectLights = true
    renderer.render(scene, camera);

    // stats.end();
    TWEEN.update();
    window.requestAnimationFrame(tick);
};

const getScreenshot = () => {
    renderer.render(scene, camera);
    return renderer.domElement.toDataURL();
};

const takeScreenshot = () => {
    const screenshot = getScreenshot();
    const link = document.createElement("a");
    link.href = screenshot;

    let name = "";
    name += selectedFrameMaterial.value.id + "-";
    name += selectedDeskMaterial.value.id + "-";
    name += tabletopSize.width + "-";
    name += tabletopSize.depth + "-";
    name += selectedDeskRadius.value;

    link.download = name + ".png";
    link.click();
};

const setDeskMaterial = (material, selectMaterial = false) => {
    if (selectMaterial) {
        selectedDeskMaterial.value = material;
    }

    tableTopInnerMaterial.color.set(material.color_inside);
    tableTopInnerMaterial.roughness =
        selectedDeskMaterial.value.roughness_inside;
    tableTopInnerMaterial.metalness =
        selectedDeskMaterial.value.metalness_inside;

    tableTopOuterMaterial.color.set(material.color_outside);
    tableTopOuterMaterial.roughness =
        selectedDeskMaterial.value.roughness_outside;
    tableTopOuterMaterial.metalness =
        selectedDeskMaterial.value.metalness_outside;

    if (material.textureMap) {
        tableTopOuterMaterial.color.set(0xffffff);
        // tableTopInnerMaterial.color.set(0xffffff);
        tableTopOuterMaterial.map = material.textureMap;
        tableTopInnerMaterial.map = material.textureMap;
    } else {
        tableTopOuterMaterial.map = null;
        tableTopInnerMaterial.map = null;
    }

    if (material.bumpMap) {
        tableTopOuterMaterial.bumpMap = material.bumpMap;
        tableTopInnerMaterial.bumpMap = material.bumpMap;
    } else {
        tableTopOuterMaterial.bumpMap = null;
        tableTopInnerMaterial.bumpMap = null;
    }
    if (material.roughnessMap) {
        tableTopOuterMaterial.roughnessMap = material.roughnessMap;
        tableTopInnerMaterial.roughnessMap = material.roughnessMap;
    } else {
        tableTopOuterMaterial.roughnessMap = null;
        tableTopInnerMaterial.roughnessMap = null;
    }

    if (material.normalMap) {
        tableTopOuterMaterial.normalMap = material.normalMap;
        tableTopInnerMaterial.normalMap = material.normalMap;
    } else {
        tableTopOuterMaterial.normalMap = null;
        tableTopInnerMaterial.normalMap = null;
    }

    if (material.normalScale) {
        tableTopOuterMaterial.normalScale = material.normalScale;
    }

    tableTopOuterMaterial.needsUpdate = true;
    tableTopInnerMaterial.needsUpdate = true;
};

const setFrameMaterial = (material, selectMaterial = false) => {
    if (selectMaterial) {
        selectedFrameMaterial.value = material;
    }
    frameMaterial.color.set(material.color_inside);
};

const updateFrame = () => {
    if (frame) {
        frame.updateFrame(tabletopSize, frameMaterial, tableHeight.value);
    } else {
        frame = new TableFrame(tabletopSize, frameMaterial, tableHeight.value);
        scene.add(frame);
    }
};

const updateAccessories = () => {
    if (accessoryObjects) {
        scene.remove(accessoryObjects);
    }
    accessoryObjects = new Accessories(
        tabletopSize,
        tableHeight,
        selectedAccessories.value
    );
    scene.add(accessoryObjects);
};

const preRenderTextures = (materials) => {
    // Create a TextureLoader instance
    const loader = new THREE.TextureLoader();
    materials.map((material) => {
        return new Promise((resolve, reject) => {
            if (material.texture) {
                let texture = loader.load(
                    "/textures/wood/" + material.texture + "/color.jpg"
                );
                let roughnessMap = loader.load(
                    "/textures/wood/" + material.texture + "/depth.jpg"
                );

                texture.colorSpace = THREE.SRGBColorSpace;
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.offset.set(0.5, 0.5);
                texture.repeat.set(0.01, 0.005);
                texture.rotation = Math.PI * 0.5;
                texture.anisotropy = 32;
                material.textureMap = texture;
                material.roughnessMap = roughnessMap;
            } else {
                let normalMap = loader.load("/textures/wood/metal/normal.png");
                const repeater = 0.03;
                normalMap.repeat.set(repeater, repeater);
                normalMap.wrapS = normalMap.wrapT = THREE.RepeatWrapping;
                normalMap.offset.set(0.5, 0.5);

                material.normalMap = normalMap;
                material.normalScale = new THREE.Vector2(1.5, 1.5);
            }
        });
    });
};
const toggleDeskSetup = () => {
    if (!desktop) {
        desktop = new DeskSetup(tableHeight.value);
    }

    showDesktop.value = !showDesktop.value;

    if (showDesktop.value) {
        scene.add(desktop);
    } else {
        scene.remove(desktop);
    }
};

const initDeskReceiver = async () => {
    if (!window.config.deskReceiver.isEnabled) {
        return;
    }

    const response = await window.axios.get(
        route("generate-desk-receiver-demo-code")
    );

    deskReceiverDemoCode.value = response.data.code;

    deskReceiver = new DeskReceiver({
        host: window.config.deskReceiver.host,
        port: window.config.deskReceiver.port,
        token: response.data.token,
    });

    deskReceiver.connect();

    deskReceiver.onSetHeight((data) => {
        updateDeskHeight(Math.floor(data.height / 10));
    });

    deskReceiver.onRequestState(() => {
        notifyStateUpdate();
        reportConnectAppDemo();
        showDownloadModal.value = false;
    });
};

const notifyStateUpdate = () => {
    if (!deskReceiver) {
        return;
    }

    deskReceiver.giveState({
        height: tableHeight.value * 10,
    });
};
const setBaseMaterials = () => {
    tableTopOuterMaterial = new THREE.MeshStandardMaterial({
        side: THREE.DoubleSide,
    });

    tableTopInnerMaterial = new THREE.MeshStandardMaterial({
        side: THREE.DoubleSide,
    });

    frameMaterial = new THREE.MeshStandardMaterial({
        color: selectedFrameMaterial.value.color_inside,
        roughness: 0.3,
        metalness: 0.5,
        side: THREE.DoubleSide,
    });

    setDeskMaterial(deskMaterials.value[0], true);
    setFrameMaterial(props.frameMaterials[0], true);
};

let moveInterval = null;

const startMovingDesk = (direction) => {
    stopMovingDesk();
    moveInterval = setInterval(() => {
        const newHeight = tableHeight.value + direction;
        if (newHeight >= 75 && newHeight <= 120) {
            updateDeskHeight(newHeight);
        }
    }, 100);
};

const stopMovingDesk = () => {
    if (moveInterval) {
        clearInterval(moveInterval);
        moveInterval = null;
    }
};

onMounted(() => {
    preRenderTextures(deskMaterials.value);
    setBaseMaterials();
    initThreeJSScene();
    tick();
    calculatePrice();
    if (props.preview) {
        cameraToPreviewBase(2000);
    } else {
        cameraToBase(2000);
    }
    scene.lightOn(2000);
    renderEnvMap();
    setTimeout(() => {
        if (props.desk) {
            presetTableFromDesk(props.desk);
        }
        presetTableFromLink();
    }, 300);
    setTimeout(() => {
        toggleDeskSetup();
    }, 2000);
    window.addEventListener("message", (event) => {
        if (event.data.type === "desk.update-height") {
            updateDeskHeight(event.data.args.height);
        }
    });
});

let page = usePage();

const appleAppStoreUrl = computed(() => {
    return page.props.appleAppStoreUrl;
});
const googlePlayStoreUrl = computed(() => {
    return page.props.googlePlayStoreUrl;
});
</script>
